import React from "react"
import { isMobile } from "@digits-shared/helpers/devicesHelper"

export const Desktop: React.FC<React.PropsWithChildren> = ({ children }) => {
  if (isMobile) return null
  return <>{children}</>
}
